// taskForm.steps.ts

export type TaskProfileContext = {
  registrant_type?: 'self' | 'parent';
};

export const taskSteps: Array<{ key: string; title: string; fields: string[] }> = [
  {
    key: 'learnerType',
    title: 'Кто будет заниматься',
    fields: ['studentType', 'studentName'],
  },
  {
    key: 'grades',
    title: 'Класс обучения',
    fields: ['grades'],
  },
  {
    key: 'subjectGoal',
    title: 'Цель занятия',
    fields: ['goal'],
  },
  {
    key: 'teacherGender',
    title: 'Пол репетитора',
    fields: ['teacherGender'],
  },
  {
    key: 'duration',
    title: 'Планируемая длительность занятий',
    fields: ['duration'],
  },
  {
    key: 'locations',
    title: 'Место занятий',
    fields: ['locations'],
  },
  {
    key: 'schedule',
    title: 'Когда удобно заниматься?',
    fields: ['studyTime'],
  },
  {
    key: 'comment',
    title: 'Пожелания',
    fields: ['comment'],
  },
  {
    key: 'price',
    title: 'Стоимость занятия',
    fields: ['priceFrom', 'priceTo'],
  },
  {
    key: 'trial',
    title: 'Пробное занятие',
    fields: ['trial'],
  },
];

export const getVisibleSteps = (values: Record<string, unknown>, _profile?: TaskProfileContext) => {
  const studentType = values.studentType as string | undefined;

  return taskSteps.filter((step) => {
    if (step.key === 'grades') {
      // Пока тип ученика не выбран, считаем шаг «Класс» - иначе счётчик прыгал «1 из 9» → «2 из 10».
      return !studentType || studentType === 'school';
    }

    return true;
  });
};
